import React from 'react';

import './styles.css';

import { Dots } from "react-activity";

function ActivityIndicator() {
    return (
        <div className="activity-indicator-component">
            <Dots />
        </div>
    )
}

export default ActivityIndicator;